import { waterMeterTypes as waterMeterTypesFromServer } from '../../../../server/common/constants/WaterMeters.constants'
import { c5Types as c5TypesFromServer } from '../../../../server/common/constants/C5.constants'
import { prvnTypes as prvnTypesFromServer } from '../../../../server/common/constants/PRVN.constants'
import HelpIcon from '@mui/icons-material/Help'
import React from 'react'
import { HotWaterMeter } from '../icons/HotWaterMeter'
import { ColdWaterMeter } from '../icons/ColdWaterMeter'
import { Temperature } from '../icons/Temperature'

const waterMeterTypes = {
	TV: {
		...waterMeterTypesFromServer.TV,
		icon: <HotWaterMeter width={'44px'} />,
		color: (palette) => 'red'
	},
	SV: {
		...waterMeterTypesFromServer.SV,
		icon: <ColdWaterMeter width={'44px'} />,
		color: (palette) => palette.light.main
	},
	SV_K: {
		...waterMeterTypesFromServer.SV_K,
		icon: <ColdWaterMeter width={'44px'} />,
		color: (palette) => palette.light.main
	},
	TV_K: {
		...waterMeterTypesFromServer.TV_K,
		icon: <HotWaterMeter width={'44px'} />,
		color: (palette) => 'red'
	},
	SV_G: {
		...waterMeterTypesFromServer.SV_G,
		icon: <ColdWaterMeter width={'44px'} />,
		color: (palette) => palette.light.main
	},
	TV_G: {
		...waterMeterTypesFromServer.TV_G,
		icon: <HotWaterMeter width={'44px'} />,
		color: (palette) => 'red'
	},
	SV_WC: {
		...waterMeterTypesFromServer.SV_WC,
		icon: <ColdWaterMeter width={'44px'} />,
		color: (palette) => palette.light.main
	},
	TV_WC: {
		...waterMeterTypesFromServer.TV_WC,
		icon: <HotWaterMeter width={'44px'} />,
		color: (palette) => 'red'
	}
}

export const allWaterMetersTypes = [
	waterMeterTypes.TV,
	waterMeterTypes.SV,
	waterMeterTypes.TV_K,
	waterMeterTypes.SV_K,
	waterMeterTypes.TV_G,
	waterMeterTypes.SV_G,
	waterMeterTypes.TV_WC,
	waterMeterTypes.SV_WC
]

const c5Types = {
	C5: {
		...c5TypesFromServer.default,
		icon: <Temperature fill={'#ff9e43'} width={'44px'} />,
		color: (palette) => palette.secondary.main
	}
}

const prvnTypes = {
	PRVN: {
		...prvnTypesFromServer.default,
		icon: <Temperature fill={'#ff9e43'} width={'44px'} />,
		color: (palette) => palette.secondary.main
	}
}

export const sensorTypes = {
	...waterMeterTypes,
	...c5Types,
	...prvnTypes
}

export const getSensorDefById = (id) => {
	switch (id) {
		case 'SV':
			return sensorTypes.SV
		case 'TV':
			return sensorTypes.TV
		case 'SV_K':
			return sensorTypes.SV_K
		case 'TV_K':
			return sensorTypes.TV_K
		case 'SV_G':
			return sensorTypes.SV_G
		case 'TV_G':
			return sensorTypes.TV_G
		case 'SV_WC':
			return sensorTypes.SV_WC
		case 'TV_WC':
			return sensorTypes.TV_WC
		case 'C5':
			return sensorTypes.C5
		case 'PRVN':
			return sensorTypes.PRVN
		default:
			return {
				...waterMeterTypesFromServer.UNDEFINED,
				icon: <HelpIcon color={'disabled'} />,
				color: () => undefined
			}
	}
}

export const PAGE_SIZE_ALL = 100000
